import { Component, ContentChildren, Input, OnDestroy, QueryList } from '@angular/core';
import { AccordionComponent } from '../accordion/accordion.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'opac-accordion-group',
  templateUrl: './accordion-group.component.html',
  styleUrls: ['./accordion-group.component.scss'],
})
export class AccordionGroupComponent implements OnDestroy {
  private toggleSubscriptions: Subscription[] = [];
  private accordions: AccordionComponent[] = [];

  /**
   * Selects all AccordionComponent's inside group to handle them
   */
  @ContentChildren(AccordionComponent, { descendants: true }) set accordionsContentChildren(accordions: QueryList<AccordionComponent>) {
    this.accordions = accordions.toArray();

    if (!this.multiple) {
      this.handleMultipleAccordions();
    } else {
      this.toggleSubscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });
    }
  }

  /**
   * Determines if divider lines should be renderer between accordions
   */
  @Input() lines = false;
  /**
   * Determines if only one accordion in the group can be opened simultaneously
   */
  @Input() multiple = false;

  ngOnDestroy(): void {
    this.toggleSubscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  private handleMultipleAccordions() {
    this.accordions.forEach((accordion) => {
      this.toggleSubscriptions.push(accordion.toggle.subscribe(({ open }) => {
        if (!open) {
          return;
        }

        this.accordions.forEach((a) => {
          if (a.isOpen) {
            a.closeAccordion();
          }
        });

        accordion.openAccordion();
      }));
    });
  }
}
